<template>
  <!-- Con esto se agrega el sidebard de aplicaciones -->
  <BaseView>

    <div :class="project?.frontStyle === 'classic' ? 'project-base-view-classic' : 'project-base-view-discord'">
      <!-- Discord navbar -->
      <MNavbar :frontStyle="project?.frontStyle"/>

      <!-- Contenido dinamico -->
      <div :class="project?.frontStyle === 'classic' ? 'slot-front-style-classic' : 'slot-front-style-discord'">
        <slot></slot>
      </div>

      <!-- Right bar: usuarios conectados -->
      <RightBar :frontStyle="project?.frontStyle"/>

    </div>

    <UserProfile v-if="showProfile && project?.frontStyle === 'discord'" v-model:dialog="showProfile"  style="position: fixed;"/>

    <!-- Buscador de elementos -->
    <v-dialog v-model="showSearchDialog" width="40%" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="searchQuery"
            label="Buscar elemento..."
            prepend-inner-icon="mdi-magnify"
            @keyup="handleSearchInput"
            clearable
            ref="searchInput"
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
          <v-list v-else>
            <v-list-item v-for="(result, index) in searchResults" :key="index">
                <v-list-item-content @click="viewElement(result)" style="user-select: none; cursor: pointer;">
                  <v-list-item-title>{{ result.description }}</v-list-item-title>
                  <v-list-item-subtitle>{{ result.type }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeSearchDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Buscador de reuniones -->
    <v-dialog v-model="showMeetingSearchDialog" width="40%" hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <v-text-field
            v-model="meetingSearchQuery"
            label="Buscar reunión..."
            prepend-inner-icon="mdi-magnify"
            @keyup="handleMeetingSearchInput"
            clearable
            ref="meetingSearchInput"
          ></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-progress-circular v-if="meetingLoading" indeterminate color="primary"></v-progress-circular>
          <v-list v-else>
            <v-list-item v-for="(result, index) in meetingSearchResults" :key="index">
                <v-list-item-content @click="viewMeeting(result)" style="user-select: none; cursor: pointer;">
                  <v-list-item-title>🔊 {{ result.number }}. {{ result.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ result.date }}</v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeMeetingSearchDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <TrelloCard v-if="showCard" 
      :card="selectedCard" 
      :dialog="showCard" 
      @update:dialog="closeCard"
    />

    <!-- Atajos de teclado flotantes -->
    <div class="keyboard-shortcuts" style="display: none">
      <p><strong>ctrl + e:</strong> Buscar elemento dialógico</p>
      <p><strong>ctrl + p:</strong> Buscar proyecto</p>
      <p><strong>ctrl + k:</strong> Buscar reunión</p>
    </div>

  </BaseView>
</template>

<script>
// Todo: mover los modales de búsqueda a un componente aparte
import RightBar from "@/components/project/RightBar.vue";
import UserProfile from "@/components/project/navbar/UserProfile.vue"
import BaseView from "../BaseView.vue";
import api from '@/api.js';
import MNavbar from "@/components/project/MNavbar.vue";
import TrelloCard from "@/components/pmo/trello/TrelloCard.vue";
export default {
  name: 'ProjectBaseView',
  components: {
    BaseView,
    MNavbar,
    UserProfile,
    RightBar,
    TrelloCard,
  },
  computed: {
    showUserProfile(){
      return this.$store.state.showUserProfile;
    },
    showCard(){
      return this.$store.state.showTrelloCard;
    },
    selectedCard(){
      return this.$store.state.selectedCard;
    },
    project(){
      return this.$store.state.project;
    }
  },
  watch: {
    project(){
      if(this.project && this.project.iconUrl){
        document.title = this.project.tabName || this.project.name;
        document.getElementById("favicon").href = this.project.iconUrl;
      }else{
        console.warn("El proyecto no tiene un icono definido.");
      }
    }
  },
  data() {
    return {
      showProfile: false,
      showSearchDialog: false,
      searchQuery: '',
      searchResults: [],
      loading: false,
      searchTimeout: null,
      // selectedCard: {},
      showMeetingSearchDialog: false,
      meetingSearchQuery: '',
      meetingSearchResults: [],
      meetingLoading: false,
      meetingSearchTimeout: null,
    }
  },
  methods: {
    iniciarSocket() {
      // Unirse a la sala del proyecto
      this.$socket.emit('event_join', { 
        room: this.$route.params.projectId,
        user: JSON.parse(localStorage.getItem("user"))}
      );

      // Escuchar eventos
      if(!this.project.options?.useChat) return;

      this.$socket.on('new_message', (payload) => {
        console.log('mensaje recibido: ', payload);

        // Si no está en la ruta del chat, aumentar el contador
        // Si está viendo el chat, no aumentar el contador
        if (this.$route.name !== 'MeetingWareChat' || document.visibilityState !== 'visible') {
          this.$store.commit('addNewMessageCount');
          this.sendNotification(payload.user.name, payload.message);
        }

        this.$store.commit('pushMessage', payload)
      })
    },
    toggleUserProfile(){
      this.$store.commit("switchUserProfile");
    },
    sendNotification(email, message) {
      if (!window.Notification) return;

      const firstName = email.split(".")[0];
      const name = firstName.charAt(0).toUpperCase() + firstName.slice(1);
      const body = `${name}: ${message ?? "Tienes un nuevo mensaje."}`;
      const icon = this.project?.iconUrl || undefined;
      const title = this.project?.name || "Notificación";

      const createNotification = () => {
        new Notification(title, { body, icon });
      };

      if (Notification.permission === "granted") {
        createNotification(); // ✅ Se muestra directamente
      } else if (Notification.permission !== "denied") {
        Notification.requestPermission().then(permission => {
          if (permission === "granted") {
            createNotification(); // ✅ Se muestra si el usuario da permiso
          }
        });
      }
    },
    async getProject() {
      try {
        const projectResponse = await api.get(`/api/project/getProjectbyID/${this.$route.params.projectId}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token`)}`,
          },
        });

        this.$store.commit('setProject', projectResponse.data);
        if(typeof this.project === 'string' && this.project === ''){
          window.location.href = '/home';
        }

      } catch (error) {
        console.log('Home.vue: Error al cargar proyecto desde backend.', error);
      }
    },
    async getProjectUsers(){
      try{
        const response = await api.post(`/api/user/getUsersByEmails`, {emails: this.project.userMembers});
        const data = response.data;
        
        // Guardar los usuarios en un mapa para acceder por ID
        this.$store.commit('set', {att: 'project_users', value: data});
        // console.log('Usuarios del proyecto:', this.$store.state.project_users);
      }catch(e){
        console.log(e);
      }
    },
    openSearchDialog() {
      this.showSearchDialog = true;
      // Hacer focus en el input de búsqueda
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    },
    closeSearchDialog() {
      this.showSearchDialog = false;
    },
    handleSearchInput() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.performSearch();
      }, 1000);
    },
    async performSearch() {
      this.loading = true;
      const queryArray = this.searchQuery.split(/[\s,.]+/);
      console.log('query array:', queryArray);
      try {
        const response = await api.post(`/api/element/project/${this.$route.params.projectId}/search`, {
          query: queryArray
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        });
        this.searchResults = response.data;
        console.log('resultados', this.searchResults);
      } catch (error) {
        console.error('Error al realizar la búsqueda:', error);
      } finally {
        this.loading = false;
      }
    },
    viewElement(element) {
      // this.selectedCard = element;
      this.$store.commit('setSelectedCard', element);
      this.$store.commit('switchTrelloCard');
    },
    closeCard() {
      this.$store.commit('switchTrelloCard');
    },
    openMeetingSearchDialog() {
      this.showMeetingSearchDialog = true;
      // Hacer focus en el input de búsqueda
      this.$nextTick(() => {
        this.$refs.meetingSearchInput.focus();
      });
    },
    closeMeetingSearchDialog() {
      this.showMeetingSearchDialog = false;
    },
    handleMeetingSearchInput() {
      clearTimeout(this.meetingSearchTimeout);
      this.meetingSearchTimeout = setTimeout(() => {
        this.performMeetingSearch();
      }, 1000);
    },
    async performMeetingSearch() {
      this.meetingLoading = true;
      try {
        const response = await api.post(`/api/meeting/search`, {search: this.meetingSearchQuery});
        this.meetingSearchResults = response.data;

        // Filtrar las reuniones que pertenecen al proyecto actual
        this.meetingSearchResults = this.meetingSearchResults.filter(meeting => meeting.project[0] === this.project._id);
        console.log('resultados', this.meetingSearchResults);
      } catch (error) {
        console.error('Error al realizar la búsqueda de reuniones:', error);
      } finally {
        this.meetingLoading = false;
      }
    },
    viewMeeting(meeting) {
      window.location.href = `/p/${this.$route.params.projectId}/meeting/${meeting._id}`;
    },
    handleKeydown(event) {
      if (event.ctrlKey && event.key === 'k') {
        event.preventDefault();
        this.openMeetingSearchDialog();
      } else if (event.ctrlKey && event.key === 'e') {
        event.preventDefault();
        this.openSearchDialog();
      }
    },
  },
  async created() {
    await this.getProject();
    this.iniciarSocket();
    await this.getProjectUsers();

    if (this.project && this.project.iconUrl) {
      document.title = this.project.tabName || this.project.name;
      document.getElementById("favicon").href = this.project.iconUrl;
    } else {
      console.warn("El proyecto no tiene un icono definido.");
    }

    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
    this.$socket.emit('event_leave', { 
      room: this.$route.params.projectId,
      user: JSON.parse(localStorage.getItem("user"))}
    );
    this.$socket.off('new_message');
  },
}
</script>

<style scoped>
.project-base-view-classic {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.project-base-view-discord {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.keyboard-shortcuts {
  user-select: none;
  position: fixed;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.0);
  color: rgba(0,0,0,0.2);
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 1000;
  text-align: center;
  font-size: small;
}

/* .keyboard-shortcuts:hover {
  background-color: rgba(0, 0, 0, 0.9);
  cursor: pointer;
  color: white;
} */

.keyboard-shortcuts p {
  margin: 5px 0;
}

.slot-front-style-discord {
  height: 100vh;
  width: 100%;
  /* background-image: url('https://wallpapers.com/images/hd/cool-discord-bsjgtmk5dbil0957.jpg'); */
}

.slot-front-style-classic {
  width: 100%;
  /* background-image: url('https://cdn.wallpaperhub.app/cloudcache/c/1/4/5/2/7/c1452724f0c3bb5a9a9a9898b4c0a0cfac091f70.jpg'); */
  height: calc(100vh - 50px);
  padding: 15px;
}
</style>